export default {
    header: "History",
    redeemedOn: "On : ",
    useNow: "Use Now",
    expired: "Expired",
    used: "Used",
    use: "Used",
 
    mark_used: "Mark Used (for staff)",
    confirm: {
        title: "Confirm after use this privilege",
        cancel: "Cancel",
        confirm: "Confirm",
    } 
}
